import './Background.css'
export default function Background() {
  return (
    <div className="oldMovieEffectSlideDeck">
      <div className='oldMovieContainer'>
      </div>
    </div>
  )
}
